"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Container.css");
require("../styles/Icon.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : IconFailure.js
* Description : Ce fichier contient la définition du composant IconFailure 
*               Ce composant affiche une icone 'rond vert' ou 'croix rouge' en fonction d'un booléen
* Date de création : 11 juillet 2025
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */
// None

/**
* IconFailure : ce composant affiche une icone 'rond vert' ou 'croix rouge' en fonction d'un booléen
*
* Type : composant 
*
* Parametres : 
*  - input -- Booléen pour déterminer l'affichage de l'icône correspondante
*             Si booléen = 0, icône = 'rond vert', sinon icône = 'croix rouge'
*/function IconFailure(_ref) {
  var input = _ref.input;
  // Render component
  if (input === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "failure-green-circle",
      children: "G"
    });
  } else {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "failure-red-cross",
      children: "X"
    });
  }
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
IconFailure.propTypes = {
  input: _propTypes["default"].number
};
var _default = exports["default"] = IconFailure;